<template>
  <v-container>
    <v-row>
      <v-col cols="5">
        <v-row> {{ $t("camera") }}: {{ licensePlates.camera_name }} </v-row>

        <v-row v-show="false">
          {{ $t("read") }} {{ $t("time") }} :
          {{ translateTime(licensePlates.read_timestamp) }}
        </v-row>

        <v-row>
          {{ $t("detect") }} {{ $t("time") }} :
          {{ translateTime(licensePlates.timestamp) }}
        </v-row>

        <v-row>
          {{ $t("licensePlate") }} {{ $t("count") }}:
          {{ licensePlates.license_plates.length }}
        </v-row>

        <v-row>
          <v-dialog width="1280">
            <template v-slot:activator="{ on, attrs }">
              <v-col v-bind="attrs" v-on="on">
                <GuardianSnapshot
                  :image="'data:image/png;base64,' + licensePlates.snapshot"
                  :fences="licensePlates.fences"
                  :objects="licensePlates.license_plates"
                  :max-height="500"
                  :max-width="500"
                ></GuardianSnapshot>
              </v-col>
            </template>

            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar dense color="primary">
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="dialog.value = false">
                      {{ $t("close") }}
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <GuardianSnapshot
                        :image="
                          'data:image/png;base64,' + licensePlates.snapshot
                        "
                        :fences="licensePlates.fences"
                        :objects="licensePlates.license_plates"
                      ></GuardianSnapshot>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </template>
          </v-dialog>
        </v-row>

        <v-row>
          <v-carousel
            v-model="licensePlate_idx"
            height="300"
            hide-delimiters
            light
          >
            <v-carousel-item
              v-for="(license_plate, idx) in licensePlates.license_plates"
              :key="idx"
            >
              <v-row>
                <v-col align="center">
                  <v-dialog width="1280">
                    <template v-slot:activator="{ on, attrs }">
                      <v-col v-bind="attrs" v-on="on">
                        <v-img
                          :src="
                            'data:image/png;base64,' + license_plate.crop_image
                          "
                          height="100"
                          width="200"
                          contain
                        ></v-img>
                      </v-col>
                    </template>

                    <template v-slot:default="dialog">
                      <v-card>
                        <v-toolbar dense color="primary">
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn dark text @click="dialog.value = false">
                              {{ $t("close") }}
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>

                        <v-list>
                          <v-list-item>
                            <v-list-item-content>
                              <v-img
                                :src="
                                  'data:image/png;base64,' +
                                  license_plate.crop_image
                                "
                                contain
                              ></v-img>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row class="display-2" justify="center">
                <v-col cols="6" align="center">
                  <v-text-field
                    v-model="license_plate.number"
                    :label="$t('licensePlate')"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col align="center">
                  <v-btn @click="updateLicensePlate(licensePlates)">
                    {{ $t("update") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </v-row>
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="6">
        <v-row class="display-2">
          {{ $t("licensePlate") }}: {{ selectedLicensePlate.number }}
        </v-row>

        <v-row :class="'display-2' + ' ' + listColor + '--text'">
          {{ $t("list_type") }}: {{ $t(selectedLicensePlate.list_type) }}
        </v-row>

        <v-row :class="'display-2' + ' ' + listColor + '--text'">
          {{ $t("plate_type") }}: {{ $t(selectedLicensePlate.plate_type) }}
        </v-row>

        <v-row class="display-2"> {{ $t("main_file") }} : </v-row>

        <v-row>
          <v-col v-if="mainfile != null">
            <v-row> {{ $t("channel") }}: {{ mainfile.channel_uuid }} </v-row>

            <v-row>
              {{ $t("licensePlate") }}: {{ mainfile.license_plate }}
            </v-row>

            <v-row> {{ $t("list_type") }}: {{ mainfile.list_type }} </v-row>

            <v-row> {{ $t("area") }}: {{ mainfile.area }} </v-row>

            <v-row>
              {{ $t("chinese") }} {{ $t("name") }}: {{ mainfile.chinese_name }}
            </v-row>

            <v-row>
              {{ $t("english") }} {{ $t("name") }}: {{ mainfile.english_name }}
            </v-row>

            <v-row> {{ $t("company") }}: {{ mainfile.company }} </v-row>

            <v-row> {{ $t("department") }}: {{ mainfile.department }} </v-row>

            <v-row>
              {{ $t("employee") }} {{ $t("number") }}:
              {{ mainfile.employee_number }}
            </v-row>

            <v-row> {{ $t("ID_number") }}: {{ mainfile.ID_number }} </v-row>

            <v-row> {{ $t("phone") }}: {{ mainfile.phone }} </v-row>

            <v-row> {{ $t("address") }}: {{ mainfile.address }} </v-row>

            <v-row>
              {{ $t("parking_space") }} {{ $t("number") }}:
              {{ mainfile.parking_space_number }}
            </v-row>

            <v-row>
              {{ $t("parking") }} {{ $t("type") }}: {{ mainfile.parking_type }}
            </v-row>

            <v-row>
              {{ $t("time") }} {{ $t("period") }}: {{ mainfile.time_period }}
            </v-row>

            <v-row>
              {{ $t("extra_field") }}1: {{ mainfile.extra_field_1 }}
            </v-row>

            <v-row>
              {{ $t("extra_field") }}2: {{ mainfile.extra_field_2 }}
            </v-row>

            <v-row>
              {{ $t("extra_field") }}3: {{ mainfile.extra_field_3 }}
            </v-row>
          </v-col>

          <v-col v-else>
            {{ $t("no-mainfile") }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GuardianSnapshot from "@/components/guardian/GuardianSnapshot";
import { updateLicensePlate } from "@/endpoint/licensePlate";
import { translateTime } from "@/plugins/util";

export default {
  name: "LicensePlateItem",
  components: {
    GuardianSnapshot,
  },
  props: ["licensePlates"],
  data() {
    return {
      licensePlate_idx: 0,
    };
  },
  computed: {
    selectedLicensePlate() {
      let selectedLicensePlate =
        this.licensePlates.license_plates[this.licensePlate_idx];

      return selectedLicensePlate;
    },
    mainfile() {
      if (this.selectedLicensePlate.main_file != null) {
        return this.selectedLicensePlate.main_file;
      }

      return null;
    },
    listColor() {
      if (this.selectedLicensePlate.list_type == "whitelist") {
        return "green";
      } else if (this.selectedLicensePlate.list_type == "blacklist") {
        return "red";
      } else if (this.selectedLicensePlate.list_type == "VIP") {
        return "orange";
      }

      return "green";
    },
  },
  watch: {
    licensePlates() {
      this.licensePlate_idx = 0;
    },
  },
  methods: {
    translateTime: translateTime,
    updateLicensePlate(item) {
      let newItem = JSON.parse(JSON.stringify(item));
      delete newItem.snapshot;
      newItem.license_plates.forEach((license_plate) => {
        delete license_plate.crop_image;
      });

      let data = {};
      data.license_plate = newItem;

      updateLicensePlate(data)
        .then(() => {
          this.$store.dispatch("openSnackbar", {
            message: this.$t("update") + " " + this.$t("success"),
          });
        })
        .catch(() => {
          this.$store.dispatch("openSnackbar", {
            message: this.$t("update") + " " + this.$t("failed"),
          });
        });
    },
  },
};
</script>

<style>
.licensePlate {
  border-width: 1px;
  border-style: solid;
}
</style>
